import React, { ButtonHTMLAttributes } from 'react';
import cc from 'classnames';
import { Button as MuiButton } from '@material-ui/core';

import noop from 'utils/noop';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Button.module.css';

export enum Themes {
  primary = 'primary',
  secondary = 'secondary',
}

export enum Sizes {
  big = 'big',
  small = 'small',
}

type Props = {
  theme?: Themes;
  size?: Sizes;
  fullWidth?: boolean;
};

const Button = ({
  theme = Themes.primary,
  size = Sizes.big,
  fullWidth,
  children,
  className,
  disabled,
  type = 'button',
  onClick = noop,
}: Props & ButtonHTMLAttributes<HTMLButtonElement>) => (
  <MuiButton
    type={type}
    className={cc(className, styles.btn, styles[theme], styles[size], { fullWidth })}
    onClick={onClick}
    disabled={disabled}
    disableFocusRipple
  >
    {children}
  </MuiButton>
);

export default Button;
